export default __webpack_public_path__ + "static/media/fullscreen.ba2dc3eb.svg";